import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"text-align":"center"}
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  function isWeChat(): boolean {
    const ua: string = window.navigator.userAgent.toLowerCase();
    const match: RegExpMatchArray | null = ua.match(/MicroMessenger/i);
    return !!match && match[0] == "micromessenger";
  }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (isWeChat())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, " 请在微信浏览器中打开 "))
}
}

})